module.exports = __webpack_public_path__ + "static/media/fashion_category.2c1da18a.jpg";